<template>
  <div class="filter">
    <div class="field_left">
      <search-input
          input-class="search"
          v-model="formFields.search"
          @input="onChange"
      ></search-input>
    </div>
    <div class="field_right">
      <select-box
          id="testing"
          v-model="formFields.subscriber_type"
          :options="subscriberTypesOptions"
          @input="onChange"
      >
        <translate class="translate">Typ předplatného</translate>
      </select-box>
    </div>
    <div class="field_left">
      <select-box id="dateFrom"
                  v-model="formFields.id_report"
                  :options="datesFrom"
                  @input="onDateFromChange"
      >
        <translate class="translate">Zobrazit stav k</translate>
      </select-box>
    </div>
    <div class="field_right">
      <select-box id="dateTo"
                  v-model="formFields.id_report_to"
                  :options="datesTo"
                  @input="onDateToChange"
      >
        <translate class="translate">Porovnat s reportem</translate>
      </select-box>
    </div>
    <div class="field_left">
      <select-box
          id="growth"
          v-model="formFields.state_change"
          :options="stateChangeOptions"
          :disabled="!formFields.id_report_to"
          @input="onChange"
      >
        <translate class="translate">Změna stavu</translate>
      </select-box>
    </div>
    <div class="field_right">
      <select-box
          id="growthTarget"
          v-model="formFields.subject_of_change"
          :options="subjectOfChangeOptions"
          :disabled="!formFields.id_report_to"
          @input="onChange"
      >
        <translate class="translate">Předmět změny stavu</translate>
      </select-box>
    </div>
    <div class="field_left">
      <select-box
          id="category"
          v-model="formFields.category"
          :options="categoryOptions"
          @input="onChange"
      >
        <translate class="translate">Kategorie operátora</translate>
      </select-box>
    </div>
    <div class="field_right">
      <select-box id="businessModel"
                  v-model="formFields.business_model"
                  :options="businessModels"
                  @input="onChange"
      >
        <translate class="translate">Business model</translate>
      </select-box>
    </div>
    <div class="field_left">
      <select-box
          id="operatorActive"
          v-model="formFields.operator_active"
          :options="activeOptions"
          @input="onChange"
      >
        <translate class="translate">Aktivita operátora</translate>
      </select-box>
    </div>
    <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
  </div>
</template>

<script>
import {SET_SETTING} from "@/store/mutation-types"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "ReportsListFilter",
  mixins: [listActions],
  props:{
    filterData: Object
  },
  data() {
    return {
      formFields: {
        search: "",
        subscriber_type: "t",
        id_report: null,
        id_report_to: null,
        state_change: null,
        subject_of_change: null,
        business_model: null,
        operator_active: null,
      }
    }
  },
  computed: {
    subscriberTypesOptions() {
      return [
        {id: 't', text: this.$gettext('Všechny typy')},
        {id: 'co', text: this.$gettext('Pouze běžní odběratelé')},
        {id: 'wt', text: this.$gettext('Kromě testovacích odběratelů')},
        {id: 'to', text: this.$gettext('Pouze testovací odběratelé')},
        {id: 'po', text: this.$gettext('Pouze promo odběratelé')},
      ]
    },

    categoryOptions() {
      return [
        {id: null, text: this.$gettext('Všechny')},
        {id: '1', text: this.$gettext('Testovací')},
        {id: '0', text: this.$gettext('Produkční')},
      ]
    },

    stateChangeOptions(){
      return [
        {id: null, text: this.$gettext('Všechny')},
        {id: 'growth', text: this.$gettext('Přírůstek')},
        {id: 'decrease', text: this.$gettext('Úbytek')},
      ];
    },

    subjectOfChangeOptions(){
      return [
        {id: null, text: this.$gettext('Neurčeno')},
        {id: 'channel_package_count', text: this.$gettext('Počet přiřazených balíčků')},
        {id: 'paid_device_count', text: this.$gettext('Počet fakturovaných odběratelů')},
        {id: 'firstscreen_device_above_limit_count', text: this.$gettext('Počet firstscreen zařízení nad limit')},
        {id: 'subscribers_count', text: this.$gettext('Počet aktivních odběratelů')},
      ];
    },

    activeOptions(){
      return [
        {id: null, text: this.$gettext('Všechny')},
        {id: true, text: this.$gettext('Pouze aktivní')},
        {id: false, text: this.$gettext('Pouze neaktivní')},
      ];
    },

    subjectOfChangeIds(){
      return this.subjectOfChangeOptions.map(item => item.id);
    },

    datesFrom(){
      return "report_dates" in this.filterData? this.filterData["report_dates"] : [];
    },

    datesTo(){
      let options = "report_dates" in this.filterData? [...this.filterData["report_dates"]] : [];
      options = options.filter((item)=>{
        return item.id < this.formFields.id_report;
      })
      options.unshift({id: null, text: this.$gettext('Neurčeno')})
      return options;
    },

    businessModels(){
      let options = "business_models" in this.filterData? [...this.filterData["business_models"]] : [];
      options.unshift({id: null, text: this.$gettext('Všechny')})
      return options;
    }
  },
  methods:{
    getEntities() {
    },
    setDefault(defaults){
      this.formFields = {...this.formFields, ...defaults};
      this.formFieldsDefaults = {...this.formFields};
      this.loadAdditionalDefaults(defaults);
    },
    onDateFromChange(){
      this.formFields.id_report_to = null;
      this.onDateToChange();
    },
    onDateToChange(){
      if(this.formFields.id_report_to == null){
        this.formFields.state_change = null;
        this.formFields.subject_of_change = null;
      }
      this.onChange();
    },
    saveFilterValues() {
      this.setCustomUserSetting('search', this.formFields.search)
      this.setCustomUserSetting('subscriber_type', this.formFields.subscriber_type)
      this.setCustomUserSetting('id_report', this.formFields.id_report)
      this.setCustomUserSetting('id_report_to', this.formFields.id_report_to)
      this.setCustomUserSetting('state_change', this.formFields.state_change)
      this.setCustomUserSetting('subject_of_change', this.formFields.subject_of_change)
      this.setCustomUserSetting('category', this.formFields.category)
      this.setCustomUserSetting('business_model', this.formFields.business_model)
      this.setCustomUserSetting('operator_active', this.formFields.operator_active)
    },
    setCustomUserSetting(settingKey, settingValue) {
      this.$store.dispatch(SET_SETTING, {module: 'reports', settings: settingValue, key: settingKey})
    },
    loadAdditionalDefaults(defaults) {
      let anyChanges = false
      if (this.loadCustomDefaultByKey('search', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('subscriber_type', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('id_report', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('id_report_to', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('state_change', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('subject_of_change', defaults, this.subjectOfChangeIds)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('category', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('business_model', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('operator_active', defaults)) {
        anyChanges = true
      }
      if(anyChanges){
        this.onChange();
      }
      return anyChanges
    },
    loadCustomDefaultByKey(settingKey, defaults, allowedValues = null) {
      let data = {module: 'reports', key: settingKey}
      if (this.$store.getters.hasSetting(data)) {
        let settings = this.$store.getters.getSetting(data)
        if(!defaults.hasOwnProperty(settingKey) || !defaults[settingKey]
            || (settingKey == 'subscriber_type' && defaults[settingKey] == 't')) {
          if(!allowedValues || (allowedValues.isArray && allowedValues.includes(value))) {
            this.formFields[settingKey] = settings;
            return true;
          }
        }
      }
      return false
    },
    onChange(){
      this.saveFilterValues();
      this.$emit('onChange', this.formFields);
    },
    resetFilter(){
      this.formFields = {...this.formFieldsDefaults};
      this.onChange();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/reports/ReportsListFilter.vue